// extracted by mini-css-extract-plugin
export default {"text":"ErrorBoundary_text__Gmnvi"};